module.exports = __webpack_public_path__ + "static/media/38-3.e5765a3d.mp3";